import React, { JSX } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import invariant from 'tiny-invariant';

import { ErrorMessages, FullPageLoader } from '../../common/components';
import { ChildPageHeading } from '../../common/components/ChildPageHeading';
import { Routes } from '../../config/routes';
import { useTranslations } from '../../contexts/LocalizationContext';
import { useFaqQuestion, useUpdateFaqQuestion } from '../../services/frequently-asked-questions';
import QuestionForm from './QuestionForm';

const QuestionUpdate = (): JSX.Element => {
  const translations = useTranslations();
  const { id } = useParams<{ id: string }>();
  invariant(id, 'id is not set within the route');
  const navigate = useNavigate();
  const {
    mutate: updateFaqQuestion,
    isLoading: isUpdatingFaqQuestion,
    error: modifyFaqQuestionError,
  } = useUpdateFaqQuestion();
  const { data: faqQuestion, isFetching: isFetchingFaqQuestion, error: loadFaqQuestionError } = useFaqQuestion(id);

  if (isFetchingFaqQuestion || isUpdatingFaqQuestion) {
    return (
      <FullPageLoader show>
        <Box h={100} />
      </FullPageLoader>
    );
  }

  return (
    <>
      <ChildPageHeading>{translations('faq_question_update_question')}</ChildPageHeading>
      <ErrorMessages errors={[loadFaqQuestionError, modifyFaqQuestionError]} />
      <QuestionForm
        isLoading={isUpdatingFaqQuestion}
        onSubmit={(values) =>
          updateFaqQuestion(
            { id, values },
            {
              onSuccess: () => navigate(Routes.FREQUENTLY_ASKED_QUESTIONS_PATH),
            },
          )
        }
        data={faqQuestion}
      />
    </>
  );
};

export default QuestionUpdate;
